export const basePath = '/digital-dossiers';

export * from './get-information';
